import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

export const Animation = keyframes`
	0% {
		transform: translate3d(-30%, 0, 0);
	}
	100% {
		transform: translate3d(30%, 0, 0);
	}
`;

export const Wrapper = styled.div<{ animationTime?: number; bgColor?: string }>`
	position: relative;

	@media ${({ theme }) => theme.medias.mobile} {
		width: inherit;
	}

	&:before {
		content: ' ';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: -18%;
		z-index: 1;
		width: 141%;
		animation: ${Animation} ${({ animationTime }) => animationTime}ms linear forwards infinite;
		background: linear-gradient(to right, #fff0 46%, #ffffff59 50%, #fff0 54%) 50% 50%;
		background-size: 150vw;
	}

	span,
	p,
	strong,
	a,
	h3 {
		background-color: ${({ bgColor }) => bgColor};
	}
`;

export const ItemConversation = styled.div`
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid #ecedf2;
	padding: 20px 10px;
	height: 100%;

	@media ${({ theme }) => theme.medias.desktop} {
		padding: 20px 14px 20px 24px;
	}
`;

export const ItemConversationContent = styled.div`
	display: flex;
	width: 100%;
`;

export const ItemLeftBox = styled.div`
	display: flex;
	width: 100%;
`;

export const ItemVehicleImage = styled.div`
	min-width: 56px;
	height: 56px;
	margin-right: 8px;
`;

export const ItemContent = styled.div`
	flex: 1 2 auto;
`;

export const ItemTitle = styled.h3`
	width: 100%;
	height: 16px;
`;

export const ItemVehicleInfo = styled.p`
	height: 15px;
	margin-top: 5px;
`;

export const ItemUserName = styled.p`
	margin-top: 3px;
	height: 15px;
`;

export const ItemMessage = styled.div`
	width: 100%;
	margin-top: 5px;
`;

export const ItemLastMessage = styled.p`
	width: 100%;
	height: 16px;
	margin-top: 5px;
`;
